import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const toolsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadComponentUserStatus: builder.query({
      query: ({ id, ciid }) =>
        (config.GetComponentUserStatus || "") + id + "&ciid=" + ciid,
      providesTags: ["ComponentUserStatus"],
    }),
    updateComponentsUserStatus: builder.mutation({
      query: (data) => ({
        url: config.UpdateComponentStatus || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ComponentUserStatus"],
    }),
  }),
});

export const {
  useLoadComponentUserStatusQuery,
  useLazyLoadComponentUserStatusQuery,
  useUpdateComponentsUserStatusMutation,
} = toolsApiSlice;
